import React from "react"
import PropTypes from "prop-types"
import "./ReadOnlyField.scss"

const ReadOnlyField = ({ size = "middle", placeholder, className, children, ellipsis }) => {
  const classNames = ["read-only-field", `read-only-field-${size}`]
  if (className) classNames.push(className)
  if (ellipsis) classNames.push("read-only-field-ellipsis")

  const renderContents = () => {
    if (children === true || children === false) return children.toString() // for switch data
    if (children || children === 0) return children
    if (placeholder) return placeholder
    return <span>&nbsp;</span>
  }

  return <div className={classNames.join(" ")}>{renderContents()}</div>
}

ReadOnlyField.propTypes = {
  size: PropTypes.oneOf(["small", "middle", "large"]),
  placeholder: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  ellipsis: PropTypes.bool,
}

export default ReadOnlyField
